<script setup lang="ts">
import { Search } from 'lucide-vue-next';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@/components/ui/select';

defineProps<{
    search: string;
    statusFilter: string;
    sourceFilter: string;
    availableSources: string[];
}>();

const emit = defineEmits<{
    (e: 'update:search', value: string): void;
    (e: 'update:statusFilter', value: string): void;
    (e: 'update:sourceFilter', value: string): void;
    (e: 'apply'): void;
}>();
</script>

<template>
    <div
        class="flex flex-wrap items-center gap-4 rounded-lg border border-border bg-card p-4 shadow-sm"
    >
        <div class="relative min-w-75 flex-1">
            <Search
                class="absolute top-1/2 left-3 h-4 w-4 -translate-y-1/2 text-muted-foreground"
            />
            <Input
                :model-value="search"
                placeholder="Rechercher (titre, auteur, DOI…)"
                class="rounded-lg pl-10"
                @update:model-value="emit('update:search', $event as string)"
                @keyup.enter="emit('apply')"
            />
        </div>

        <Select
            :model-value="statusFilter"
            @update:model-value="emit('update:statusFilter', $event as string)"
        >
            <SelectTrigger class="w-45 rounded-lg">
                <SelectValue placeholder="Statut" />
            </SelectTrigger>
            <SelectContent>
                <SelectItem value="all">Tous les statuts</SelectItem>
                <SelectItem value="pending">Sans décision</SelectItem>
                <SelectItem value="included">À inclure</SelectItem>
                <SelectItem value="excluded">À exclure</SelectItem>
                <SelectItem value="maybe">À revoir</SelectItem>
            </SelectContent>
        </Select>

        <Select
            v-if="availableSources.length > 0"
            :model-value="sourceFilter"
            @update:model-value="emit('update:sourceFilter', $event as string)"
        >
            <SelectTrigger class="w-45 rounded-lg">
                <SelectValue placeholder="Source" />
            </SelectTrigger>
            <SelectContent>
                <SelectItem value="all">Toutes les sources</SelectItem>
                <SelectItem
                    v-for="src in availableSources"
                    :key="src"
                    :value="src"
                >
                    {{ src }}
                </SelectItem>
            </SelectContent>
        </Select>

        <Button variant="secondary" class="rounded-lg" @click="emit('apply')">
            Appliquer
        </Button>
    </div>
</template>
